import downloadAPI from '../../api/Download'
import * as types from '../mutation-types'

// STATE
const state = {
    Downloads: [],
    DownloadsFilters: {}
}

// GETTERS
const getters = {
    Downloads: state => state.Downloads,
    DownloadsFilters: state => state.DownloadsFilters
}

// ACTIONS
const actions = {
    getDownloads({ commit }, params) {
        return new Promise((resolve, reject) => {
            downloadAPI.getDownloads(downloads => {
                if (downloads.status > 300) {
                  reject(downloads.data);
                } else {
                  commit(types.RECEIVE_DOWNLOADS, { downloads })
                  resolve()
                }
            }, params)
        })
    },
    sendDownloads({ commit }, params) {
      return new Promise((resolve, reject) => {
        downloadAPI.sendDownloads((response) => {
          if (response.status > 300) {
            reject(response.data);
          } else {
            resolve(response)
          }
        }, params)
      })
    },
    getProductInfoAsCsv({commit}, params) {
      return new Promise((resolve, reject) => {
        downloadAPI.getProductInfoAsCsv((response) => {
          if (response.status > 300) {
            reject(response.data);
          } else {
            resolve(response)
          }
        }, params);
      });
    }
}

// MUTATIONS
const mutations = {
    [types.RECEIVE_DOWNLOADS] (state, { downloads }) {
        state.Downloads = downloads.Products
        state.DownloadsFilters = downloads.Filters
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Downloads.js